import { type ActionItem } from 'shared/ui'
import { truthy } from 'shared/lib'
import { type Phone } from 'entities/Phone/model/Phone'
import { verifyNumber } from 'entities/Phone/ui/actions/verifyNumber/verifyNumber'
import { EnumUserRoles } from 'entities/Users'
import type { IAssignInboxProps } from 'entities/Phone/ui/actions/assignInbox/ui'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { cancelNumberLandline } from './cancelNumberLandline/cancelNumberLandline'
import { cancelNumberDisabled } from './cancelNumberDisabled/cancelNumberDisabled'
import { releaseNumber } from './releaseNumber/releaseNumber'
import { resumeNumber } from './resumeNumber/resumeNumber'
import { assignInbox } from './assignInbox/assignInbox'

export const getPhoneActions = (
  phone: Phone,
  entities: IEntitiesStore,
  {
    loadData,
    onCloseAssignInboxModalModal,
  }: {
    loadData: () => Promise<void>
    onCloseAssignInboxModalModal?: IAssignInboxProps['onCloseAssignInboxModalModal']
  }
): ActionItem[] => {
  const { organizationStore, usersStore } = entities
  const { isTwilioNumberVendor } = organizationStore
  const isManageAvailable =
    usersStore.user?.role === EnumUserRoles.ADMIN || usersStore.user?.role === EnumUserRoles.OWNER
  const isVerifyAvailable = phone.status === 'unverified'
  const isPending = phone.status === 'pending'
  const isReleaseAvailable =
    !isTwilioNumberVendor &&
    ((phone.isAssigned && phone.isMultiNumber) || (!phone.isAssigned && !phone.isLandline))

  if (!isManageAvailable) return []

  const isAssignInbox = onCloseAssignInboxModalModal && phone.status !== 'failed' && !isPending
  const isResumeNumber = phone.status === 'failed' || isPending
  const isCancelNumberDisabled = phone.status === 'failed' || (isPending && !phone.isLandline)
  const isCancelNumberLandline =
    phone.status === 'verifiedLandline' || (isPending && phone.isLandline)

  const unassignedActions: ActionItem[] = phone.isAssigned
    ? []
    : [
        isAssignInbox && assignInbox([phone.origin], onCloseAssignInboxModalModal, entities),
        isResumeNumber && resumeNumber(phone),
        isCancelNumberDisabled && cancelNumberDisabled(),
        isCancelNumberLandline && cancelNumberLandline(phone, loadData, entities),
      ].filter(truthy)

  return [
    isVerifyAvailable && verifyNumber(),
    ...unassignedActions,
    isReleaseAvailable && releaseNumber(phone, entities, loadData),
  ].filter(truthy)
}
